import React from 'react'
import Slider from 'react-slick'
import Carousel from '../../../json/carousel' //Importe le fichier JSON.
import '../../../styles/stylecarousel.css'

function SimpleSlider() {
  //   Pour un Slider.
  // const settings = {
  //     dots: true,
  //     infinite: true,
  //     // Vitesse du slide.
  //     speed: 4000,
  //     // Nombre d'images affichés à chaque fois.
  //     slidesToShow: 1,
  //     // Nombre d'image glissée à chaque fois.
  //     slidesToScroll: 1,
  //     autoplay: true,
  //     // Temps d'affichage.
  //     autoplaySpeed: 7000
  //   };

  //   Pour un fade.
  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 2000,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    autoplaySpeed: 5000,
    pauseOnHover: false,
  }

  return (
    <div id="slider-container" className="slider-container">
      <Slider {...settings}>
        {Carousel.images.map((item) => (
          <div key={item.id}>
            <img src={item.imageUrl} alt="images" />
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default SimpleSlider
